var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ServiceDataBase } from "@/modules/services/models/ServiceData";
import { MapProperty, MapGetMethod, MapSetMethod } from "@/utils/mapper/ClassMapper";
import date from 'date-and-time';
var User = (function (_super) {
    __extends(User, _super);
    function User() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closingTimeStamp = null;
        _this.closingTimeStampStr = '';
        _this.country = '';
        _this.createDate = '';
        _this.createDateStr = '';
        _this.dateOfBirth = '';
        _this.email = '';
        _this.firstName = '';
        _this.hasUnsubscribed = false;
        _this.isApproved = false;
        _this.isCommercialCommunicationAccepted = false;
        _this.isCommercialCommunicationAcceptedDate = '';
        _this.isLockedOut = false;
        _this.isTermsAccepted = false;
        _this.isTermsAcceptedDate = '';
        _this.language = '';
        _this.lastLockoutDate = '';
        _this.lastLoginDate = '';
        _this.lastName = '';
        _this.lastPasswordChangedDate = '';
        _this.origin = '';
        _this.password = '';
        _this.pictureUrl = '';
        _this.publicUrl = '';
        _this.registerdFromIPAddress = '';
        _this.shortDescription = '';
        _this.title = '';
        _this.userId = '';
        _this.isDeleted = false;
        _this.linkedinProfileUrl = '';
        return _this;
    }
    User.prototype.setData = function (data) {
        if (this.closingTimeStamp) {
            var finalTimestampInt = 0;
            if (this.closingTimeStamp.includes('/Date(')) {
                var timestamp = this.closingTimeStamp.slice(6);
                var offset = '';
                var isMinus = false;
                if (timestamp.includes('+')) {
                    offset = timestamp.slice(timestamp.indexOf('+'));
                    timestamp = timestamp.slice(0, timestamp.indexOf('+'));
                }
                else if (timestamp.includes('-')) {
                    offset = timestamp.slice(timestamp.indexOf('-'));
                    timestamp = timestamp.slice(0, timestamp.indexOf('-'));
                    isMinus = true;
                }
                if (timestamp.endsWith(')/'))
                    timestamp = timestamp.slice(0, -2);
                if (offset.endsWith(')/'))
                    offset = offset.slice(0, -2);
                offset = offset.slice(0, 2);
                var timestampInt = parseInt(timestamp);
                var offsetInt = parseInt(offset) * (isMinus ? -1 : 1);
                finalTimestampInt = timestampInt + offsetInt * 60 * 60 * 1000;
                console.log('this.closingTimeStamp', this.closingTimeStamp, timestamp, offset, timestampInt, offsetInt);
            }
            else {
                finalTimestampInt = parseInt(this.closingTimeStamp);
            }
            var timestampDate = new Date(finalTimestampInt);
            console.log('timestampDate', timestampDate);
            this.closingTimeStampStr = date.format(timestampDate, 'YYYY/MM/DD HH:mm:ss [GMT]Z');
        }
    };
    User.prototype.getData = function (mapGetMethodParameter) {
    };
    __decorate([
        MapProperty({ from: 'Candidate.ClosingTimeStamp', to: 'ClosingTimeStamp' })
    ], User.prototype, "closingTimeStamp", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Country', to: 'Country' })
    ], User.prototype, "country", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.CreateDate', to: 'CreateDate' })
    ], User.prototype, "createDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.CreateDateStr', to: 'CreateDateStr' })
    ], User.prototype, "createDateStr", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.DateOfBirth', to: 'DateOfBirth', tags: ['update'] })
    ], User.prototype, "dateOfBirth", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Email', to: 'Email', tags: ['update'] })
    ], User.prototype, "email", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.FirstName', to: 'FirstName', tags: ['update'] })
    ], User.prototype, "firstName", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.HasUnsubscribed', to: 'HasUnsubscribed' })
    ], User.prototype, "hasUnsubscribed", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsApproved', to: 'IsApproved' })
    ], User.prototype, "isApproved", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsCommercialCommunicationAccepted', to: 'IsCommercialCommunicationAccepted' })
    ], User.prototype, "isCommercialCommunicationAccepted", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsCommercialCommunicationAcceptedDate', to: 'IsCommercialCommunicationAcceptedDate' })
    ], User.prototype, "isCommercialCommunicationAcceptedDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsLockedOut', to: 'IsLockedOut' })
    ], User.prototype, "isLockedOut", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsTermsAccepted', to: 'IsTermsAccepted' })
    ], User.prototype, "isTermsAccepted", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.IsTermsAcceptedDate', to: 'IsTermsAcceptedDate' })
    ], User.prototype, "isTermsAcceptedDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Language', to: 'Language', tags: ['update'] })
    ], User.prototype, "language", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.LastLockoutDate', to: 'LastLockoutDate' })
    ], User.prototype, "lastLockoutDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.LastLoginDate', to: 'LastLoginDate' })
    ], User.prototype, "lastLoginDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.LastName', to: 'LastName', tags: ['update'] })
    ], User.prototype, "lastName", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.LastPasswordChangedDate', to: 'LastPasswordChangedDate' })
    ], User.prototype, "lastPasswordChangedDate", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Origin', to: 'Origin' })
    ], User.prototype, "origin", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Password', to: 'Password' })
    ], User.prototype, "password", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.PictureUrl', to: 'PictureUrl' })
    ], User.prototype, "pictureUrl", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.PublicUrl', to: 'PublicUrl' })
    ], User.prototype, "publicUrl", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.RegisterdFromIPAddress', to: 'RegisterdFromIPAddress' })
    ], User.prototype, "registerdFromIPAddress", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.ShortDescription', to: 'ShortDescription', tags: ['update'] })
    ], User.prototype, "shortDescription", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.Title', to: 'Title' })
    ], User.prototype, "title", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.UserId', to: 'UserId' })
    ], User.prototype, "userId", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.isDeleted', to: 'isDeleted' })
    ], User.prototype, "isDeleted", void 0);
    __decorate([
        MapProperty({ from: 'Candidate.linkedinProfileUrl', to: 'linkedinProfileUrl', tags: ['update'] })
    ], User.prototype, "linkedinProfileUrl", void 0);
    __decorate([
        MapSetMethod()
    ], User.prototype, "setData", null);
    __decorate([
        MapGetMethod()
    ], User.prototype, "getData", null);
    return User;
}(ServiceDataBase));
export { User };



//////////////////
// WEBPACK FOOTER
// ./src/modules/users/models/User.ts
// module id = CxZ3
// module chunks = 10